import React from "react";
import "./FlexSeparator.css";

const FlexSeparator = () => {
  return <div className={"flex-separator"} />;
};

export default FlexSeparator;
